import { render } from "./Home.vue?vue&type=template&id=587a4b64&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=587a4b64&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587a4b64"]])

export default __exports__